import type {SVGProps} from 'react'

const Pause = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.8273 16.6859" {...props}>
        <path d="M1.3955 16.6762L3.6871 16.6762C4.60175 16.6762 5.08085 16.1971 5.08085 15.2726L5.08085 1.3955C5.08085 0.446092 4.60175 0 3.6871 0L1.3955 0C0.4791 0 0 0.471092 0 1.3955L0 15.2726C0 16.1971 0.472069 16.6762 1.3955 16.6762ZM8.7869 16.6762L11.0705 16.6762C11.9949 16.6762 12.466 16.1971 12.466 15.2726L12.466 1.3955C12.466 0.446092 11.9949 0 11.0705 0L8.7869 0C7.86249 0 7.38339 0.471092 7.38339 1.3955L7.38339 15.2726C7.38339 16.1971 7.85721 16.6762 8.7869 16.6762Z" />
    </svg>
)
export default Pause
